import { Component } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';
import { filter, map } from 'rxjs/internal/operators';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'cacesa-front';
  constructor(private translate: TranslateService, private titleService: Title, public router: Router, public activatedRoute: ActivatedRoute) {
    translate.setDefaultLang('en');

  }
  ngOnInit() {
    const appTitle = this.titleService.getTitle();
    this.router
      .events.pipe(
        filter(event => event instanceof NavigationEnd),
        map(() => {

          const child = this.activatedRoute.firstChild;
          if (child.snapshot.data['title'] == "admin" || child.snapshot.data['title'] == "home") {

            return child.snapshot.children[0].children[0].data['title']
          } else {
            return child.snapshot.data['title'];
          }

          /*   return appTitle; */
        })
      ).subscribe((ttl: string) => {
        this.titleService.setTitle(ttl);
      });

  }

}
